var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.12,
    height: 10,
    viewBox: "0 0 7.12 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12.51L6.61 5 1.12 9.49",
    fill: "none",
    stroke: "#20303c"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7.12' height='10' viewBox='0 0 7.12 10'%3E %3Cmetadata%3E%3C?xpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'?%3E %3Cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01 '%3E %3Crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3E %3Crdf:Description rdf:about=''/%3E %3C/rdf:RDF%3E %3C/x:xmpmeta%3E %3C?xpacket end='w'?%3E%3C/metadata%3E %3Cdefs%3E %3Cstyle%3E .cls-1 %7B fill: none; stroke: %2320303c; stroke-width: 1px; fill-rule: evenodd; %7D %3C/style%3E %3C/defs%3E %3Cpath id='Arrow' class='cls-1' d='M1868,1051.51l5.49,4.49-5.49,4.49' transform='translate(-1866.88 -1051)'/%3E %3C/svg%3E";
export { SvgArrow1 as ReactComponent };